import {BottomNavItems} from "@/core/menu/bottomNav.models";

export const MENU_BUILDER_SETTINGS_URL = 'p/menu/page/v1/';
export const VIDEOGARDI_MOVIE_URL = 'p/videobox/broadcast/v1/movies/';
export const VIDEOGARDI_SERIES_URL = 'p/videobox/broadcast/v1/series/';
export const VIDEOGARDI_REGULAR_URL = 'p/videobox/media/v1/regularvideo/';
export const VIDEOGARDI_CONTENT_URL = 'p/videobox/broadcast/v1/content/';
export const MENU_BUILDER_GROUP = 'page_videogardi_main';

export const PAGE_HOME_KEY = 'page__home';
export const PAGE_TOOLS_KEY = 'page__tools';
export const PAGE_STORE_KEY = 'page__finance';
export const PAGE_GAME_KEY = 'page__game__main';
export const PAGE_VIDEO_KEY = 'page__film';
export const PAGE_SEARCH_KEY = 'page__search';

export const HOME_KEY = 'home';
export const TOOLS_KEY = 'tools';
export const STORE_KEY = 'store';
export const GAME_KEY = 'game';
export const VIDEO_KEY = 'video';
export const SEARCH_KEY = 'search';

export const WIDGET_WALLET = 'wb__wallet';
export const WIDGET_FAVORITE = 'wb__favorite';
export const WIDGET_EXCHANGE_RATE = 'wb__exchange__rate';
export const WIDGET_SHORTCUT_SQUARE_SWIPER = 'wb__square__shortcut__swiper';
export const WIDGET_SHORTCUT_SWIPER = 'wb__shortcut__swiper';
export const WIDGET_HORIZONTAL = 'wb__horizontal';
export const WIDGET_TOOLS = 'wb__tools';
export const WIDGET_ADVERTISEMENT = 'wb__advertisement';
export const WIDGET_BANNER_SWIPER = 'wb__banner__swiper';
export const WIDGET_BANNER_SLIDER = 'wb__banner__slider';
export const WIDGET_MEDIA_SWIPER = 'wb__swiper';
export const WIDGET_SHORT_VIDEO = 'wb__short__video';
export const WIDGET_VIDEO_GARDI_HORIZONTAL = 'wb__videogardi__horizontal';
export const WIDGET_TMK_GENRE_VIDEO = 'wb__videogardi__genre';
export const WIDGET_CALENDAR = 'wb__calendar';

export const LOADER_LARGE_SIZE = 'large';
export const LOADER_MEDIUM_SIZE = 'medium';
export const LOADER_SMALL_SIZE = 'small';

export const FILM_TAG = 'film';
export const IMAGE_PLACEHOLDER_IMAGE = '/image/placeholder.webp';


export const PLAYER_PATH = '/player/';
export const SHORT_VIDEO_PATH = '/short_video/';
export const VIDEO_GARDI_MOVIES_PATH = '/movies/';
export const VIDEO_GARDI_SERIES_PATH = '/series/';
export const MEDIA_DETAIL_PATH = '/media/';
export const SHORT_LIST_PATH = '/shortlist/';
export const VIDEO_LIST_PATH = '/videolist/';
export const MEDIA_LIST_PATH = '/medialist/';

export const LOGO_ICON = '/image/svg_ic_logo.svg';
export const LOGO_TEXT_ADDRESS = '/image/svg_ic_logo_text.svg';
export const SEARCH_ICON_ADDRESS = '/image/svg_ic_search.svg';

export const MAIN_APP_URL = 'tlbx.ir';

export const HTTP_KEY = 'http';

export const SPIN_ARROW_IMAGE = '/image/spin_arrow.png';

export const BRT_TEHRAN_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tehran_march_6_2022.svg';
export const BRT_TEHRAN_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tehran_night_march_6_2022.svg';

export const BRT_TABRIZ_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tabriz_march_6_2022.svg';
export const BRT_TABRIZ_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/brt_map_tabriz_night_march_6_2022.svg';

export const SUBWAY_TEHRAN_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tehran_feb_1_2022.svg';
export const SUBWAY_TEHRAN_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tehran_night_feb_1_2022.svg';

export const SUBWAY_TABRIZ_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tabriz_march_6_2022.svg';
export const SUBWAY_TABRIZ_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_tabriz_night_march_6_2022.svg';

export const SUBWAY_MASHHAD_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_mashhad_feb_1_2022.svg';
export const SUBWAY_MASHHAD_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_mashhad_night_feb_1_2022.svg';

export const SUBWAY_SHIRAZ_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_shiraz_march_6_2022.svg';
export const SUBWAY_SHIRAZ_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_shiraz_night_march_6_2022.svg';

export const SUBWAY_ISFAHAN_LIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_isfahan_feb_1_2022.svg';
export const SUBWAY_ISFAHAN_NIGHT_IMAGE =
    'https://toolboxmap.s3.ir-thr-at1.arvanstorage.ir/metro_map_isfahan_night_feb_1_2022.svg';

export const TEHRAN_CITY = 'tehran';
export const ISFAHAN_CITY = 'isfahan';
export const MASHHAD_CITY = 'mashhad';
export const TABRIZ_CITY = 'tabriz';
export const SHIRAZ_CITY = 'shiraz';

export const EXCHANGE_RATE_PATH = 'p/tools/v1/exchange_rate/';
export const EXCHANGE_RATE_WIDGET_PATH = 'p/tools/v1/exchange_rate/home';

export const CURRENCY_TYPE = 'currency';
export const GOLD_TYPE = 'gold';
export const COIN_TYPE = 'coin';

export const TOP_ARROW_IMAGE_PATH = '/image/arrow_up.svg';
export const DOWN_ARROW_IMAGE_PATH = '/image/arrow_down.svg';

export const COIN_IMAGE_PATH = '/image/coin.webp';
export const GOLD_IMAGE_PATH = '/image/gold.webp';
export const CURRENCY_IMAGE_PATH = '/image/currency.webp';

const ACTIVE_HOME_IMAGE = '/image/svg_ic_home.svg';
const ACTIVE_HOME_IMAGE_ACTIVE = '/image/svg_ic_home_fill.svg';

const ACTIVE_TOOLS_IMAGE = '/image/svg_ic_tools.svg';
const ACTIVE_TOOLS_IMAGE_ACTIVE = '/image/svg_ic_tools_fill.svg';

const ACTIVE_SHOP_IMAGE = '/image/svg_ic_shop.svg';
const ACTIVE_SHOP_IMAGE_ACTIVE = '/image/svg_ic_shop_fill.svg';

const ACTIVE_GAME_IMAGE = '/image/svg_ic_game.svg';
const ACTIVE_GAME_IMAGE_ACTIVE = '/image/svg_ic_game_fill.svg';

const ACTIVE_VIDEO_IMAGE = '/image/svg_ic_video.svg';
const ACTIVE_VIDEO_IMAGE_ACTIVE = '/image/svg_ic_video_fill.svg';

export const BottomItems: BottomNavItems[] = [
    {
        image: ACTIVE_HOME_IMAGE,
        activeImage: ACTIVE_HOME_IMAGE_ACTIVE,
        valueKey: HOME_KEY,
        text: 'home'
    },
    {
        image: ACTIVE_TOOLS_IMAGE,
        activeImage: ACTIVE_TOOLS_IMAGE_ACTIVE,
        valueKey: TOOLS_KEY,
        text: 'tools'
    },
    {
        image: ACTIVE_SHOP_IMAGE,
        activeImage: ACTIVE_SHOP_IMAGE_ACTIVE,
        valueKey: STORE_KEY,
        text: 'store'
    },
    {
        image: ACTIVE_VIDEO_IMAGE,
        activeImage: ACTIVE_VIDEO_IMAGE_ACTIVE,
        valueKey: VIDEO_KEY,
        text: 'videoPlus'
    },
    {
        image: ACTIVE_GAME_IMAGE,
        activeImage: ACTIVE_GAME_IMAGE_ACTIVE,
        valueKey: GAME_KEY,
        text: 'game'
    }
];

export const MNT_ACTIVE_IMAGE = '/image/svg_ic_MTN_active.svg';
export const MNT_IMAGE = '/image/svg_ic_MTN.svg';
export const HAMRAH_ACTIVE_IMAGE = '/image/svg_ic_MCI_active.svg';
export const HAMRAH_IMAGE = '/image/svg_ic_MCI.svg';
export const RIGHTEL_ACTIVE_IMAGE = '/image/svg_ic_RTL_active.svg';
export const RIGHTEL_IMAGE = '/image/svg_ic_RTL.svg';
export const SCORE_IMAGE = '/image/svg_ic_score.svg';
export const EMPTY_IMAGE = '/image/svg_ic_empty.svg';

export const RIGHTEL_REGEX = '^92[0|1|2][0-9]{7}$';
export const MTN_REGEX = '^9[3|0|4][0-9]{8}$';
export const HAMRAH_REGEX = '^9[1|9][0-9]{8}$';
export const MOBILE_REGEX = '^9[0-9]{9}$';

export const HAMRAH_OPERATOR = 'MCI';
export const MTN_OPERATOR = 'MTN';
export const RIGHTEL_OPERATOR = 'RTL';

export const BUNDLE_ADVISER_URL = 'r/payment/bundleadviser/v1/';

export const BUY_CHARGE_INQUIRY_URL = 'r/payment/charge/v1/inquiry/';
export const BUY_CHARGE_INVOICE_URL = 'r/payment/transaction/v3/invoice/charge/';
export const PAYMENT_COUPON_URL = 'r/payment/transaction/v3/coupon/';
export const CHARGE_FROM_WALLET = 'r/payment/charge/v3/buy/';
export const INCREASE_WALLET_FOR_BUY_WALLET = 'r/payment/transaction/v3/invoice/wallet/';

export const BUY_CHARGE_CHECK_COUPON_URL = 'r/payment/transaction/v1/';
export const BUY_CHARGE_COUPON_URL_TEXT = '/coupon/';

export const CHARGE_TYPE = 'charge';
export const INTERNET_PACKAGE_TYPE = 'internet';
export const BILL_TYPE = 'bill';

export const BUY_INTERNET_SETTING_URL = 'p/payment/setting/v1/';
export const BUY_INTERNET_DETAIL_URL = 'r/payment/internetpackage/v2/inquiry/';
export const BUY_INTERNET_INVOICE_URL = 'r/payment/transaction/v3/invoice/internetpackage/';
export const BUY_INTERNET_FROM_WALLET = 'r/payment/internetpackage/v3/buy/';

export const BUY_INTERNET_CHECK_COUPON_URL = 'r/payment/transaction/v1/';
export const BUY_INTERNET_COUPON_URL_TEXT = '/coupon/';

export const BILL_BUNDLE_ADVISER_URL = 'r/payment/bill/v1/user';
export const BILL_PHONE_INQUIRY_URL = 'r/payment/bill/v1/inquiry/home_phone/';
export const BILL_MOBILE_INQUIRY_URL = 'r/payment/bill/v1/inquiry/mobile/';
export const BILL_HOME_INQUIRY_URL = 'r/payment/bill/v1/inquiry/home/';
export const BILL_INVOICE_URL = 'r/payment/transaction/v3/invoice/bill/';

export const NEW_BILL_URL = '/t/bill/addNew/';
export const NEW_BILL_URL_MAIN = '/t/bill/addNew/';

export const BILL_MOBILE_TYPE = 5;
export const BILL_PHONE_TYPE = 4;
export const BILL_GAS_TYPE = 3;
export const BILL_ELECTRICITY_TYPE = 2;
export const BILL_WATER_TYPE = 1;

export const WALLET_IMAGE_PATH = '/image/wallet.webp';
export const BARCODE_IMAGE_URL = '/image/barcode_frame.svg';


export const NOTE_LIST_URL = 'r/tools/note/v1/';
export const DELETE_NOTE_LIST_URL = 'r/tools/note/v1/';

export const ADD_NOTE_IMAGE_URL = '/image/svg_ic_add_note.svg';
export const FOLDER_IMAGE_URL = '/image/svg_ic_folder.svg';

export const DELETE_IMAGE_URL = '/image/svg_ic_delete.svg';
export const EDIT_IMAGE_URL = '/image/svg_ic_edit.svg';
export const SHARE_IMAGE_URL = '/image/svg_ic_upload.svg';

export const FONT_SIZE_IMAGE_URL = '/image/svg_ic_font_size.svg';
export const PAINT_IMAGE_URL = '/image/svg_ic_paint.svg';

export const COLOR_TRANS_LIST = [
    '#EF9A9A5B',
    '#f48fb158',
    '#ce93d858',
    '#90caf958',
    '#a5d6a758',
    '#fff59d58',
    '#ffcc8058',
    '#bcaaa458',
    '#b0bec558',
    '#eeeeee58'
];

export const COLOR_LIST = [
    '#EF9A9A',
    '#f48fb1',
    '#ce93d8',
    '#90caf9',
    '#a5d6a7',
    '#fff59d',
    '#ffcc80',
    '#bcaaa4',
    '#b0bec5',
    '#eeeeee'
];

export const LOGO_WHITE_ICON = '/image/logo_white.png';

export const GET_FAVORITES_URL = 'r/menu/user/v1/favorite/';

export const WALLET_WALLET_IMAGE_PATH = '/image/wallet.png';
export const WALLET_MONEY_IMAGE_PATH = '/image/money.png';
export const WALLET_CARD_IMAGE_PATH = '/image/wallet_card_background.svg';
export const WALLET_SIM_IMAGE_PATH = '/image/sim_card_icon.svg';

export const WALLET_BALANCE_API_URL = 'r/payment/accounting/v1/wallet/balance';
export const WALLET_CHARGE_API_URL = 'r/payment/accounting/v1/wallet/charge';

export const FINANCIAL_HISTORY_URL = 'r/payment/transaction/v3/user/';

export const PAGE_URL_TAG = 'page';
export const PAGE_SIZE_URL_TAG = 'page_size';

export const DEPOSIT = 'deposit';
export const WITHDRAW = 'withdraw';

export const SUCCESS_IMAGE = '/image/svg_ic_success.svg';
export const UN_SUCCESS_IMAGE = '/image/svg_ic_error.svg';

export const WATER = '1';
export const ELECTRICITY = '2';
export const GAS = '3';
export const PHONE = '4';
export const MOBILE = '5';
export const URBAN_TOLLS = '7';
export const CAR_FINES = '9';

export const STATE_SUCCESS = 'success';
export const STATE_FAILED = 'failed';
export const STATE_RETURNED = 'returned';
export const STATE_UN_SUCCESS = 'unsuccessfull';
export const STATE_STARTED = 'started';

export const TYPE_CREDIT = 'CREDIT';
export const TYPE_DEBT = 'DEBT';

export const GET_ADS_URL = 'p/menu/page/v1/widget/';

export const ADS_LARGE_SIZE = 'large';
export const ADS_MEDIUM_SIZE = 'medium';
export const ADS_SMALL_SIZE = 'small';

export const ADS_NATIVE_TYPE = 'native';
export const ADS_BANNER_TYPE = 'banner';
export const ADS_ADMOB_TYPE = 'admob_banner';

export const BANNER_LARGE_SIZE = 'large';
export const BANNER_MEDIUM_SIZE = 'medium';
export const BANNER_SMALL_SIZE = 'small';


export const TEHRAN_METRO = 'tehran';
export const TEHRAN_DARK_METRO = 'tehran_dark';
export const ISFAHAN_METRO = 'isfahan';
export const ISFAHAN_DARK_METRO = 'isfahan_dark';
export const MASHHAD_METRO = 'mashhad';
export const MASHHAD_DARK_METRO = 'mashhad_dark';
export const SHIRAZ_METRO = 'shiraz';
export const SHIRAZ_DARK_METRO = 'shiraz_dark';
export const TABRIZ_METRO = 'tabriz';
export const TABRIZ_DARK_METRO = 'tabriz_dark';
